import {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import {useAuth} from '../../modules/auth'

const actions = [
  {
    title: 'Talepler',
    description: 'Talepleri incele ve güncelle',
    path: '/request/list',
    icon: '/media/icons/duotune/text/txt002.svg',
  },
  {
    title: 'Soru Ara',
    description: 'Bir soruya hızlıca ulaş',
    path: '/searchquestion',
    icon: '/media/icons/duotune/general/gen021.svg',
  },
  {
    title: 'İtirazlar',
    description: 'İtirazları ve yanıtları gör',
    path: '/my-objections/list',
    icon: '/media/icons/duotune/communication/com012.svg',
  },
  {
    title: 'Kullanıcılar',
    description: 'Kullanıcı bilgilerini yönet',
    path: '/applicationuser/list',
    icon: '/media/icons/duotune/communication/com014.svg',
  },
  {
    title: 'Arşiv',
    description: 'Tamamlanmış paketleri aç',
    path: '/request-archive/list',
    icon: '/media/icons/duotune/general/gen061.svg',
  },
  {
    title: 'Ayarlar',
    description: 'Bildirim ve sistem ayarları',
    path: '/setting/list',
    icon: '/media/icons/duotune/coding/cod001.svg',
  },
]

const AdminQuickActions: FC = () => {
  const {currentUser} = useAuth()
  const roleName = currentUser?.roleName ?? currentUser?.RoleName ?? ''

  if (roleName.trim().toUpperCase() !== 'ADMIN') return null

  return (
    <div className='card mb-8'>
      <div className='card-header border-0 pt-5'>
        <div>
          <h2 className='card-title fw-bolder text-gray-900 mb-1'>Hızlı İşlemler</h2>
          <div className='text-gray-700 fs-6'>
            Günlük kullanılan yönetim ekranlarına tek adımda ulaşın.
          </div>
        </div>
      </div>
      <div className='card-body pt-4'>
        <div className='row g-4'>
          {actions.map((action) => (
            <div className='col-12 col-sm-6 col-lg-4 col-xxl-3' key={action.path}>
              <Link
                to={action.path}
                className='d-flex align-items-center border border-gray-300 rounded p-4 h-100 bg-hover-light-primary text-decoration-none'
                aria-label={`${action.title}: ${action.description}`}
              >
                <span className='symbol symbol-45px me-4'>
                  <span className='symbol-label bg-light-primary'>
                    <KTSVG path={action.icon} className='svg-icon-2 svg-icon-primary' />
                  </span>
                </span>
                <span className='min-w-0'>
                  <span className='d-block fw-bolder fs-6 text-gray-900'>{action.title}</span>
                  <span className='d-block text-gray-700 fs-7 lh-sm mt-1'>
                    {action.description}
                  </span>
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AdminQuickActions
